import axios from "axios";
import { apiUrl } from "../../config";

export const addFrameColorMaster = (acc) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/frame-color-master/create`,
      acc
    );

    return {
      response,
    };
  } catch (error) {}
};

export const getAllFrameColorMasterLength = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/frame-color-master/getAllFrameColorMasterLength`
    );
    console.log("%%%111%%%", response.data.results[0].tot);
    return { response };
  } catch (error) {}
};

export const getAllFrameColorMaster =
  (offset, row_count) => async (dispatch) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/frame-color-master/getAllFrameColorMaster/${offset}/${row_count}`
      );
      dispatch({
        type: "GET_FRAMECOLOR_SUCCESS",
        payload: response.data.results,
      });
    } catch (error) {}
  };

export const updateFrameColorMaster = (pur) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/frame-color-master/update`,
      pur
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const deleteFrameColorMaster = (accid) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/frame-color-master/delete`,
      {
        accid,
      }
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    alert("Something Went Wrong");
    console.log(error);
  }
};

export const searchFrameColorMaster = (val) => async (dispatch) => {
  const data = { id: val };
  try {
    const response = await axios.post(
      `${apiUrl}/api/frame-color-master/search`,
      data
    );
    return { response };
    // window.location.reload()
  } catch (error) {
    return { error };
  }
};

export const getAllFrameColorNames = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/frame-color-master/getallFrameColorNames`
    );
    //console.log('##123456##',response.data.results)
    dispatch({ type: "GET_FCNAME_SUCCESS", payload: response.data.results });
  } catch (error) {}
};
